<template>
	<form-field label="Tenant" has-icon icon-class="fa-chevron-down">
		<select v-model="selectedTenant" aria-label="Selected Tenant">
			<option value="" selected>-- {{ allTenantsLabel }} --</option>
			<option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
				{{ tenant.companyName }}
			</option>
		</select>
	</form-field>
</template>

<script>
export default {
	props: {
		modelValue: [String, Number],
		tenants: {
			type: Array,
			required: true
		},
		allTenantsLabel: {
			type: String,
			default: 'All Tenants'
		}
	},
	emits: ['update:modelValue'],
	computed: {
		selectedTenant: {
			get() {
				return this.modelValue || this.$global.getSelectedTenant() || ''
			},
			set(value) {
				this.$emit('update:modelValue', value)
				this.$global.setSelectedTenant({ target: { value } })
			}
		}
	}
}
</script>
